const activeSubMenuScroller = () => {
  const subMenuContainer = document.getElementById('site-sub-navigation');
  const subMenu = document.getElementById('sub-navigation-list');

  if (!subMenuContainer || !subMenu) {
    return;
  }

  const activeSubItem = subMenu.querySelector('.active');

  if (!activeSubItem || activeSubItem?.classList.contains('first')) {
    return;
  }

  subMenuContainer.scrollLeft = activeSubItem.offsetLeft;
};

export default activeSubMenuScroller;
